import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app.store'
import adherent from './modules/adherent.store'
import creationContrat from './modules/creation-contrat.store'
import recolte from './modules/recolte.store'
import graine from './modules/graine.store'
import contrat from './modules/contrat.store'
import comparaisonQualite from './modules/comparaison-produits.store'
import commercialisation from './modules/commercialisation.store'
import culture from './modules/culture.store'
import refParcellaire from './modules/ref-parcellaire.store'
import demandeInfosAbonnement from './modules/abonnement/demande-infos-abonnement.store'
import offreAbonnement from './modules/abonnement/offre-abonnement.store'
import temoignageAbonnement from './modules/abonnement/temoignage-abonnement.store'
import accesSouscriptionAbonnement from './modules/abonnement/acces-souscription-abonnement.store'
import assolement from './modules/assolement.store'
import rendement from './modules/rendement.store'
import reperesEconomiques from './modules/reperes-economiques.store'
import parametresExploitation from './modules/parametres-exploitation.store'
import faq from './modules/faq.store'
import filtresComparaison from './modules/filtres-comparaison.store'
import filtresContrat from './modules/filtres-contrat.store'
import filtresApports from './modules/filtres-apports.store'
import tiers from './modules/tiers.store'
import reglementCampagne from './modules/reglement-campagne.store'
import application from './modules/application.store'
import user from './modules/user.store'
import mouvement from './modules/mouvement.store'
import redirection from './modules/redirection.store'
import comparateurMarge from './modules/comparateur-marges.store'
import parametresExploitationGroupe from './modules/parametres-exploitation-groupe.store'
import prix from './modules/prix.store'
import syntheseAnalyse from './modules/synthese-analyse.store'
import contratVente from './modules/contrat-vente.store'
import cloture from './modules/cloture.store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    adherent,
    app,
    application,
    assolement,
    commercialisation,
    comparaisonQualite,
    contrat,
    contratVente,
    creationContrat,
    culture,
    refParcellaire,
    demandeInfosAbonnement,
    offreAbonnement,
    temoignageAbonnement,
    accesSouscriptionAbonnement,
    faq,
    filtresComparaison,
    filtresContrat,
    filtresApports,
    graine,
    parametresExploitation,
    recolte,
    reglementCampagne,
    rendement,
    reperesEconomiques,
    tiers,
    user,
    mouvement,
    redirection,
    comparateurMarge,
    parametresExploitationGroupe,
    prix,
    syntheseAnalyse,
    cloture
  },
  strict: process.env.NODE_ENV !== 'production'
})
export default store
